module.exports = __webpack_public_path__ + "static/media/BuiltSmartSlide02.7973233d.jpg";